import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const PersonalDataIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="none" className={props.className}>
		<path
			fill="#00BFF1"
			d="M12 0H8C4.229 0 2.343 0 1.172 1.172 0 2.343 0 4.229 0 8c0 3.771 0 5.657 1.172 6.828C2.343 16 4.229 16 8 16h4c3.771 0 5.657 0 6.828-1.172C20 13.657 20 11.771 20 8c0-3.771 0-5.657-1.172-6.828C17.657 0 15.771 0 12 0Z"
			opacity=".2"
		/>
		<path
			fill="#00BFF1"
			d="M11.25 5a.75.75 0 0 1 .75-.75h5a.75.75 0 1 1 0 1.5h-5a.75.75 0 0 1-.75-.75Zm1 3a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75Zm1 3a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM7 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6c4 0 4-.895 4-2S9.21 9 7 9s-4 .895-4 2 0 2 4 2Z"
		/>
	</svg>
);
